export const environment = {
  DEFAULT_SIG_KEY: 'HYUEBD12EW',
  AUTHORIZATION: 'Authorization',
 //API_BASE_URL:'http://localhost:8080/AlertDashboard'
 //API_BASE_URL : 'https://adalerts.altametrics.com/AlertDashboard',
 API_BASE_URL : 'https://apalerts.altametrics.com/AlertDashboard'

};
